import request from './index.js'
// export const privacy_policy = (params) => request.post("/about/privacy_policy", params);
export const report_impact = (params) => request.get("/report/impact", {params});
export const report_activity = (params) => request.get("/report/activity", {params});
export const questionnaire_impact_result_info = (params) => request.get("/questionnaire/impact_result_info", {params});
export const questionnaire_impact_result_save = (params) => request.post("/questionnaire/impact_result_save", params);
